const pluralizeAsset = (count) => `${count} ${count === 1 ? 'asset' : 'assets'}`;

const translate = (t, key, fallback, values) => t ? t(key, fallback, values) : fallback;

const removalOutcomeSummary = (bulkJob, containerName, t) => {
    const removed = bulkJob?.removed_count || 0;
    const skipped = bulkJob?.skipped_count || 0;
    const failed = bulkJob?.failed_count || 0;
    const location = containerName ? ` from ${containerName}` : '';

    const sentences = [
        translate(
            t,
            'message-removal-outcome-removed',
            `${pluralizeAsset(removed)} removed${location}.`,
            {count: removed, name: containerName}
        )
    ];
    if(skipped) {
        sentences.push(translate(
            t,
            'message-removal-outcome-skipped',
            `${pluralizeAsset(skipped)} already absent.`,
            {count: skipped}
        ));
    }
    if(failed) {
        sentences.push(translate(
            t,
            'message-removal-outcome-failed',
            `${pluralizeAsset(failed)} could not be removed.`,
            {count: failed}
        ));
    }

    return {
        type: failed ? 'warning' : 'success',
        content: sentences.join(' ')
    };
};

const bulkJobTerminalAttrs = (job, failureMessage = 'Bulk job failed.') => {
    const state = job?.aasm_state;

    return {
        aasm_state: state,
        done: state === 'processed',
        canceled: state === 'canceled',
        error: job?.error || (['errored', 'failed'].includes(state) ? failureMessage : null)
    };
};

const bulkJobIsTerminal = (job) => (
    !!job?.done ||
    !!job?.canceled ||
    ['processed', 'failed', 'canceled'].includes(job?.aasm_state)
);

const bulkJobHasTerminalError = (job) => (
    (!!job?.error || !!job?.canceled) && bulkJobIsTerminal(job)
);

const bulkJobIsActive = (job) => {
    if(job?.canceled || ['failed', 'canceled'].includes(job?.aasm_state)) return false;
    if(job?.indexing_pending) return true;
    if(job?.aasm_state) return ['pending', 'processing', 'errored'].includes(job.aasm_state);
    if(job?.error || job?.progress == null) return false;

    return !job?.done && job.progress < 100;
};

const bulkJobCanCancel = (job) => bulkJobIsActive(job) && !bulkJobIsTerminal(job);

export {
    bulkJobCanCancel,
    bulkJobHasTerminalError,
    bulkJobIsActive,
    bulkJobIsTerminal,
    bulkJobTerminalAttrs,
    removalOutcomeSummary,
};
